import { DateTime } from "luxon";
import * as React from "react";
import { connect } from "react-redux";
import { Alert, Card } from "@mantine/core";
import ShiftApi from "../../data/api/shiftsApi";
import { StatusColors } from "../../styles/scheme";
import { IUpcomingSessionTransport } from "../../types/shifts/Shift";
import { ShiftSessionStatus } from "../../types/shifts/enums/ShiftSessionStatus";
import { toDateTime } from "../../util/date+helper";
import { PublicRosterAnchor } from "../common/Links";
import { CenteredLoader } from "../common/loader";

export interface IUpcomingShiftsProps { }

export interface IUpcomingShiftsState {
  shifts: IUpcomingSessionTransport[] | null;
  loading: boolean;
  error?: string | null;
}

class UpcomingShifts extends React.PureComponent<
  IUpcomingShiftsProps,
  IUpcomingShiftsState
> {
  constructor(props, context) {
    super(props, context);

    this.state = {
      shifts: null,
      loading: true,
    };

    ShiftApi.getUpcomingShifts()
      .then((shifts) => this.setState({ shifts, loading: false }))
      .catch((er) => this.setState({ loading: false, error: er.message }));
  }

  render() {
    const { shifts } = this.state;
    if (this.state.loading) return <CenteredLoader />;
    if (!shifts || this.state.error) {
      return (
        <Alert color="red">
          {this.state.error || "An error has occurred"}
        </Alert>
      );
    }


    return (
      <Card style={{ padding: "20px", marginBottom: "20px" }}>
        <p style={{ marginBottom: "5px" }}>
          <b style={{ fontSize: "18px", marginRight: "5px" }}>Your shifts</b>{" "}
          <span style={{ color: "darkgray" }}>next 7 days</span>
        </p>
        {shifts.length === 0 && (
          <p style={{ marginTop: "10px", marginBottom: "0" }}><em>No upcoming shifts</em></p>
        )}
        {shifts.map((s) => {
          const color = ShiftSessionStatus.toColor(s.status);

          let range: string | null = null;
          if (s.start && s.finish) {
            range = `${toDateTime(s.start).toLocaleString(
              DateTime.TIME_SIMPLE,
            )} - ${toDateTime(s.finish).toLocaleString(DateTime.TIME_SIMPLE)}`;
          }

          return (
            <div
              key={s.sessionId}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                marginTop: "20px",
              }}
            >
              <span
                style={{
                  backgroundColor: color,
                  marginRight: "10px",
                  height: "15px",
                  width: "15px",
                  borderRadius: "50%",
                  display: "inline-block",
                  float: "left",
                  border: `${StatusColors.toBorderColor(color)} 1px solid`,
                }}
              />
              <div style={{ marginLeft: "5px" }}>
                <p style={{ marginBottom: "2px" }}>{s.name}</p>
                <p
                  className="grey"
                  style={{ marginBottom: "2px", fontSize: "12px" }}
                >
                  {`${ShiftSessionStatus.toString(s.status)} · ${toDateTime(
                    s.date,
                  ).toFormat("d LLLL")}`}
                  {s.rosterToken && (
                    <>
                      {" "}
                      {" · "}{" "}
                      <PublicRosterAnchor token={s.rosterToken}>
                        See roster
                      </PublicRosterAnchor>
                    </>
                  )}
                </p>
                {range && (
                  <p
                    className="grey"
                    style={{ marginBottom: "2px", fontSize: "12px" }}
                  >
                    {range}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </Card>
    );
  }
}

const mapState2Props = (state, props) => ({
  // venues: state.venues.map
});

function mapDispatchToProps(dispatch) {
  return {
    // actions: bindActionCreators({ getPublishedAppointments }, dispatch)
  };
}

export default connect(mapState2Props, mapDispatchToProps)(UpcomingShifts);
